import { render, staticRenderFns } from "./feeDetailFeeRule.vue?vue&type=template&id=0d4f0aaa&scoped=true"
import script from "./feeDetailFeeRule.vue?vue&type=script&lang=js"
export * from "./feeDetailFeeRule.vue?vue&type=script&lang=js"
import style0 from "./feeDetailFeeRule.vue?vue&type=style&index=0&id=0d4f0aaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4f0aaa",
  null
  
)

export default component.exports